export class BulkReassignResultEntity {
  public batchId!: string;
  public count!: number;
}
